export default __webpack_public_path__ + "static/media/logo_cloudez.1df36ebc.svg";